export const CONTACT_FORM_SUBMIT = 'contact/CONTACT_FORM_SUBMIT';
export const CONTACT_FORM_SUBMIT_SUCCESS =
  'contact/CONTACT_FORM_SUBMIT_SUCCESS';
export const CONTACT_FORM_SUBMIT_FAILURE =
  'contact/CONTACT_FORM_SUBMIT_FAILURE';
